import {I18n} from '@aws-amplify/core';

import {FlexiAddButton,} from '@flexinet/ui-components';

import {
    useNavigate,
    useParams
} from 'react-router-dom';
import {moduleConfig} from "../config";

export const AddRecordButton = ({
                                    buttonText = `Add ${moduleConfig.titles.singular}`,
                                    size = 'sm',
                                    onClick,
                                }: {
    buttonText?: string,
    size?: string,
    onClick?: () => void
}) => {
    const params = useParams()
    const subscriptionId = params.id || params.subscriptionId
    const customerId = params.id && params.subscriptionId ? params.id : undefined

    const navigate = useNavigate();

    if (typeof onClick === 'undefined') {
        onClick = () => {
            const url = customerId 
                ? `/customers/${customerId}/subscriptions/${subscriptionId}/subscription-items/add`
                : `/subscriptions/${subscriptionId}/subscription-items/add`;
            navigate(url);
        };
    }

    return (
        <FlexiAddButton
            onClick={onClick}
            size={size}
        >
            {I18n.get(buttonText)}
        </FlexiAddButton>
    );
};
